import { Injectable } from '@angular/core';

import { InstrumentationService, KnownInstrumentationEvents } from '../instrumentation/instrumentation.service';
import { ObservableScope } from '../models/observable-scope.enum';
import { PaintMarkerName } from '../models/paint-marker-name.enum';
import { AngularEvents } from '../shared-context/angular-events';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { EventService } from './event.service';
import { NewTabPageService } from './new-tab-page.service';
import { PageVisibilityService } from './page-visibility.service';
import { PerformanceMeasureType, PerformanceService } from './performance.service';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class VisuallyReadyService {
    private readonly paintRecordings: Set<PaintMarkerName>;

    private paintMinAntpRecorded: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly windowService: WindowService,
        private readonly performanceService: PerformanceService,
        private readonly eventService: EventService,
        private readonly ntpService: NewTabPageService,
        private readonly instrumentationService: InstrumentationService,
        private readonly pageVisibilityService: PageVisibilityService
    ) {
        this.paintRecordings = new Set([ PaintMarkerName.SharePoint, PaintMarkerName.MRU, PaintMarkerName.Recommended ]);

        this.eventService.whenEventFired(AngularEvents.sharePointFailed, ObservableScope.PastAndFuture).then(() => {
            this.mark(PaintMarkerName.SharePoint);
        });

        this.eventService.whenEventFired(AngularEvents.mruFailed, ObservableScope.PastAndFuture).then(() => {
            this.mark(PaintMarkerName.MRU);
        });

        this.eventService.whenEventFired(AngularEvents.recommendedFailed, ObservableScope.PastAndFuture).then(() => {
            this.mark(PaintMarkerName.Recommended);
        });
    }

    public mark(marker: PaintMarkerName) {
        if (this.paintRecordings.delete(marker) && this.capabilitiesService.capabilities.antpLoaded) {
            if (this.paintRecordings.size === 0) {
                if (!this.windowService.nativeWindow.antpTtvrLogged && this.ntpService.logHistogram(NTPEvent.NTP_LAYOUT_VISUALLY_READY)) {
                    this.windowService.nativeWindow.antpTtvrLogged = true;
                }

                if (this.pageVisibilityService.isVisible()) {
                    this.performanceService.mark('Paint_Antp', PerformanceMeasureType.FromLastAppNavigationStart, DataSecurityLevel.Security, window.getCommonParamsAntp());
                    this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.AntpView, window.getCommonParamsAntp());
                }

                this.eventService.broadcastEvent({
                    name: AngularEvents.antpReady,
                    args: []
                });
            }

            if (!this.paintMinAntpRecorded) {
                if (this.pageVisibilityService.isVisible()) {
                    this.performanceService.mark('Paint_AntpMin', PerformanceMeasureType.FromLastAppNavigationStart, DataSecurityLevel.Security, window.getCommonParamsAntp());
                    this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.AntpMinView, window.getCommonParamsAntp());
                }
                this.paintMinAntpRecorded = true;
            }
        }
    }
}
